(function ($) {

    if ($.validator != undefined) {
        $.validator.setDefaults({
            ignore: ":hidden"
        });

        $.validator.unobtrusive.adapters.addBool("requiredcb", "required");

        $.validator.addMethod('umbracoforms_selectonefromlist', function(value, element) {
            var valid = false;
            $("input", $(element).closest(".checkboxlist, .radiobuttonlist")).each(function(i) {
                if ($(this).is(':checked')) {
                    valid = true;
                }
            });
            return valid;
        });

        $.validator.unobtrusive.adapters.addBool("requiredlist", "umbracoforms_selectonefromlist");

        $.validator.addMethod('umbracoforms_regex', function(value, element) {

            var regex = $(element).attr("data-regex");
            var val = $(element).val();
            if (val.length == 0) {
                return true;
            }
            return val.match(regex);
        });

        $.validator.unobtrusive.adapters.addBool("regex", "umbracoforms_regex");
        $('.umbraco-forms-form').on('click', '[type="submit"]:not(.cancel)', function (evt) {
            evt.preventDefault();
            var self = $(this);
            var frm = self.closest('form');
            frm.validate();
            if (frm.valid() && self.attr('disabled') !== 'disabled') {
                if (frm.is('[nonajax]')) {
                    frm.submit();
                }
                else {
                    var data = {};
                    var values = frm.serializeArray();
                    values.forEach(function (item, index) {
                        if (data[item.name] === undefined) { // New
                            data[item.name] = item.value || '';
                        } else {                            // Existing
                            if (!data[item.name].push) {
                                data[item.name] = [data[item.name]];
                            }
                            data[item.name].push(item.value || '');
                        }
                    });
                    frm.addClass('posting');
                    $.post({
                        method: 'POST',
                        url: location.pathname,
                        data: data,
                    })
                        .done(function () {
                            var popup = $('#' + frm.parent().attr('id').replace('umbraco_form', 'form_popup'));
                            popup.foundation('open');
                            frm[0].reset();
                            self.removeAttr('disabled');
                            frm.removeClass('posting');
                        })
                        .fail(function (data) {
                            var errorModal = $('#error');
                            errorModal.find('.message').html(data.responseText);
                            errorModal.foundation('open');
                        })
                }
                self.attr('disabled', 'disabled');

            }
        });
    }
})(jQuery);

